import { Navigate, useLocation } from 'react-router-dom'

import { env } from 'src/config/env'
import { paths } from 'src/config/paths'
import { Loading } from 'src/shared/components/ui/miscellaneous/loading'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

interface Rule {
  allowList: string[]
  paths: string[]
}

const RULES: Rule[] = [
  {
    // The following emails are allowed to access the business tab.
    allowList: [
      'integration-testing@zapier.com',
      'richard@askconrad.ai',
      'sheng@askconrad.ai',
      'sheng+1@askconrad.ai',
      'richardshkim04@gmail.com',
      'nick@askconrad.ai',
      'nick+2@askconrad.ai',
    ],
    paths: [paths.business.path, paths.business.pending.path],
  },
]

/** Prevents the user from accessing the website if they are signed in as an agent */
export default function BlockWebGuard({ children }: { children: React.ReactNode }) {
  const { data: user, isPending } = useMyUserData()
  const location = useLocation() // Get the current location
  const currentPath = location.pathname // Get the current path

  // Wait for user data to load before rendering the page.
  if (isPending) {
    return <Loading style="fullscreen" />
  }

  // Admins can access all the pages.
  let shouldBlock = ['local'].includes(env.MODE) ? false : user?.role === 'admin' ? false : true

  // Check if the user is allowed to access the current path.
  if (shouldBlock) {
    const isAllowed = RULES.some(
      (rule) => rule.paths.includes(currentPath) && rule.allowList.includes(user?.primaryEmail?.toLowerCase() || ''),
    )
    if (isAllowed) {
      shouldBlock = false
    }
  }

  if (shouldBlock) {
    return <Navigate to={paths.alert.path} replace />
  }

  return <>{children}</>
}
